import { useTranslation } from "react-i18next";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import type { TabDef } from "~/types/ui";
import type { ReactNode } from "react";

export function TabedForm({
  resourceName,
  formChild: FormChild,
  additionalProps = {},
}: {
  resourceName: string;
  additionalProps?: React.ComponentProps<any>;
  formChild: React.ComponentType<{ bulk?: boolean }>;
}) {
  const tabs: TabDef[] = [
    {
      value: "single",
      labelKey: "single",
      content: <FormChild {...additionalProps} />,
    },
    {
      value: "bulk",
      labelKey: "bulk",
      content: <FormChild bulk {...additionalProps} />,
    },
  ];
  return (
    <TabedComponent
      tabsTranslationSection={"common.tabs"}
      tabs={tabs}
      translationResource={resourceName}
    />
  );
}

export function TabedComponent({
  tabsTranslationSection,
  tabs,
  translationResource,
  informationDialog,
  onValueChange,
}: {
  tabsTranslationSection: string;
  tabs: TabDef[];
  translationResource?: string;
  informationDialog?: ReactNode;
  onValueChange?: (value: string) => void;
}) {
  const { t } = useTranslation();
  return (
    <Tabs defaultValue={tabs[0].value} onValueChange={onValueChange}>
      <TabsList className="border">
        {tabs.map((tab) => (
          <TabsTrigger key={tab.value} value={tab.value}>
            {translationResource
              ? t(`${tabsTranslationSection}.${tab.labelKey}`, {
                  resource: translationResource,
                })
              : t(`${tabsTranslationSection}.${tab.labelKey}`)}
          </TabsTrigger>
        ))}
        {informationDialog}
      </TabsList>

      {tabs.map((tab) => (
        <TabsContent key={tab.value} value={tab.value} className="w-full mt-2">
          {tab.content}
        </TabsContent>
      ))}
    </Tabs>
  );
}
